import { Star, ExternalLink } from "lucide-react";
import { business } from "@/config/business";
import { Reveal, Overline } from "@/components/Reveal";

const placeholders = [0, 1, 2];

export default function Reviews() {
  return (
    <section id="reviews" className="py-20 md:py-32 bg-white" data-testid="reviews-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16">
        <Reveal>
          <Overline>Reviews</Overline>
          <div className="mt-4 flex flex-wrap items-end justify-between gap-6">
            <h2 className="font-display text-4xl sm:text-5xl tracking-tight text-ink max-w-xl">
              Loved by Local Customers
            </h2>
            <div data-testid="reviews-summary" className="flex items-center gap-3">
              <span className="font-display text-5xl text-primary">{business.rating}</span>
              <span className="text-sm text-muted-foreground leading-snug">
                <span className="flex text-accent" aria-hidden="true">
                  {[...Array(5)].map((_, i) => (
                    <Star key={i} size={15} className="fill-accent" />
                  ))}
                </span>
                {business.reviewCount} Google reviews
                <span className="block text-[10px] uppercase tracking-widest text-accent font-semibold mt-0.5">
                  {business.verifyLabel}
                </span>
              </span>
            </div>
          </div>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-6">
          {placeholders.map((i) => (
            <Reveal key={i} delay={i * 0.1}>
              <figure
                data-testid={`review-card-${i}`}
                className="bg-soft/60 border border-primary/10 p-8 h-full flex flex-col gap-4"
              >
                <div className="flex text-accent" aria-label="5 out of 5 stars">
                  {[...Array(5)].map((_, s) => (
                    <Star key={s} size={16} className="fill-accent" aria-hidden="true" />
                  ))}
                </div>
                <blockquote className="text-sm leading-relaxed text-muted-foreground italic">
                  “Verified Google review excerpt to be added.”
                </blockquote>
                <figcaption className="mt-auto flex items-center justify-between">
                  <span className="text-sm font-semibold text-ink">Google Customer</span>
                  <span className="text-[10px] uppercase tracking-widest text-accent font-semibold">
                    {business.verifyLabel}
                  </span>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.15}>
          <div className="mt-12">
            <a
              data-testid="google-reviews-button"
              href={business.googleReviewsUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 border border-primary text-primary px-8 py-4 text-sm font-semibold uppercase tracking-widest hover:bg-primary hover:text-primary-foreground transition-colors min-h-[48px]"
            >
              See Google Reviews <ExternalLink size={15} />
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
